import api from "../api";
import pusherHelper from "../services/pusherHelper";
import dates from "../services/dates";

const state = {
  selectedDate: null,
  badge: {
    pastDue: 0,
    completedToday: 0,
    totalToday: 0
  },
  tasks: [],
};

const getters = {
  pastDueCount(state) {
    return state.badge.pastDue
  },
  completedTodayCount(state) {
    return state.badge.completedToday
  },
  todayTotalCount(state) {
    return state.badge.totalToday
  },
  tasks(state) {
    let tasks = [...state.tasks]

    // this is here to handle tasks pushed by Pusher Events
    if (state.selectedDate === null) {
      return tasks.filter(task => dates.isInPast(task.due_at))
        .sort((a, b) => new Date(a.due_at) - new Date(b.due_at))
    }

    return tasks.filter(task => dates.isDateEqual(task.due_at, state.selectedDate))
      .sort((a, b) => new Date(a.due_at) - new Date(b.due_at))
  },
};

const mutations = {
  setup(state, data) {
    state.tasks = data
  },
  updateSelectedDate(state, date) {
    state.selectedDate = date
  },
  setupBadges(state, data) {
    state.badge = {
      pastDue: data.past_due,
      completedToday: data.completed_today,
      totalToday: data.total_today
    }
  },
  updateTasksCollection(state, data) {
    state.tasks = pusherHelper.updateCollection(state.tasks, data)
  },
  teardown(state) {
    state.selectedDate = null
    state.badge = {
      pastDue: 0,
      completedToday: 0,
      totalToday: 0
    }
    state.tasks = []
  },
};

const actions = {
  getBadges({commit, state, rootGetters, getters}) {
    return api.clientStore.initDashboardTaskBadges().then(response => {
      commit('setupBadges', response.data)
    })
  },
  getTasks({commit, state, rootState, getters}, selectedDate) {
    return api.clientStore.initDashboardTasks(selectedDate).then(response => {
      commit("updateSelectedDate", selectedDate)
      commit('setup', response.data)
    })
  },
  processPusherEvent({commit, dispatch}, payload) {
    dispatch("getBadges")
    commit("updateTasksCollection", payload)
  },
  tearDown({commit, state, rootGetters, getters}) {
    commit('teardown')
  },
};

const DashboardTasks = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default DashboardTasks;
